module.exports = __webpack_public_path__ + "static/img/TALK.72bb385.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/TALK.png
// module id = 22Ff
// module chunks = 0